import 'slick-carousel';
import 'slick-carousel/slick/slick.css';

export const setSlick = (targetElement, options = {}) => {
    targetElement.slick(options);
}
